import { Trans } from "@lingui/react/macro";

import { Button } from "../../../components/ui-kit/button";
import { Dialog } from "../../../components/ui-kit/dialog";
import { CountriesRegionsPicker } from "./countries-regions-picker";

export function CellLocations(props: {
  item: any;
  patch?: any;
  onClose: () => void;
}) {
  return (
    <Dialog open onOpenChange={(open) => !open && props.onClose()}>
      <div className="flex flex-col items-start">
        <div className="self-stretch flex items-center justify-between pb-8">
          <h3 className="text-base font-bold">
            <Trans>Edit locations for: {props.item.username}</Trans>
          </h3>
          <Button onClick={props.onClose}>X</Button>
        </div>

        <CountriesRegionsPicker
          locations={props.patch ? props.patch.locations : props.item.locations}
          onChange={(newLocations) => {
            if (props.patch) {
              props.patch.locations = newLocations;
            }
          }}
          disabled={!props.patch}
        />

        <div className="self-center mt-8">
          <Button onClick={props.onClose}>
            <Trans>Close</Trans>
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
